import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

export function useRequestedVideo({ items, loading, onOpen, onMissing, param = 'video' }) {
  const [searchParams, setSearchParams] = useSearchParams();
  const requestedId = searchParams.get(param);

  useEffect(() => {
    if (loading || !requestedId) return;

    const videoId = Number(requestedId);
    const next = new URLSearchParams(searchParams);
    next.delete(param);
    setSearchParams(next, { replace: true });

    if (!Number.isFinite(videoId) || videoId <= 0) return;
    const match = (items || []).find((item) => Number(item.id) === videoId);
    if (match) {
      onOpen(match);
      return;
    }
    onMissing?.(videoId);
  }, [items, loading, onMissing, onOpen, param, requestedId, searchParams, setSearchParams]);
}
